"use strict";function startClassRoom$(s){return ddSdk_1.ddSdk.invokeAPI(apiName,s)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.startClassRoom$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.live.startClassRoom";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"5.1.19"},_a)),exports.startClassRoom$=startClassRoom$,exports.default=startClassRoom$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/live/startClassRoom.js
// module id = 962
// module chunks = 106